import React, { useState } from 'react';
import { Row, Col, Card, Accordion, Button } from 'react-bootstrap';
import VehicleList from '../components/VehicleList';
import ShoppingCart from '../components/ShoppingCart';
import OrderSummary from '../components/OrderSummary';
import { vehicles } from '../data/vehicles';
import { useSelection } from '../context/SelectionContext';

const CustomMatsPage: React.FC = () => {
  const [activeKey, setActiveKey] = useState<string>("0");
  const { selectedItems } = useSelection();

  const handleNextStep = () => {
    if (selectedItems.length === 0) {
      alert('Please select at least one vehicle before continuing.');
      return;
    }
    setActiveKey("1");
  };


  const handleAddedToCart = () => {
    setActiveKey("0");
  };

  return (
    <main className="container py-4">
      <Row>
        {/* Left side: Step-by-step selection */}
        <Col lg={8} className="selection-panel">
          <Card className="mb-4">
            <Card.Header className="order-header">
              <h2>Order Custom Mats</h2>
            </Card.Header>
            <Card.Body>
              {/* Steps accordion */}
              <Accordion activeKey={activeKey} onSelect={(key) => setActiveKey(Array.isArray(key) ? key[0] || "0" : key || "0")} id="orderSteps">
                {/* Step 1: Vehicle List */}
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    1. Select Vehicles & Quantities
                  </Accordion.Header>
                  <Accordion.Body>
                    <VehicleList vehicles={vehicles} />
                    <div className="mt-3 d-flex justify-content-end">
                      <Button 
                        variant="primary" 
                        onClick={handleNextStep}
                        disabled={selectedItems.length === 0}
                      >
                        Next
                      </Button>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>

                {/* Step 2: Confirmation */}
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    2. Confirmation
                  </Accordion.Header>
                  <Accordion.Body>
                    <h3>Confirm your order</h3>
                    <OrderSummary onAddedToCart={handleAddedToCart} />
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Card.Body>
          </Card>
        </Col>

        {/* Right side: Shopping cart */}
        <Col lg={4} className="cart-panel">
          <ShoppingCart />
        </Col>
      </Row>
    </main>
  );
};

export default CustomMatsPage;